import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQMeetingPage = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="index-sec-1 pricing-page-faq">
      <div className="container">
        <h2
          className="font--31 color-293F  fw--400"
          style={{ justifyContent: "center", textAlign: "center" }}
        >
          NxaTel Pricing FAQs
        </h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What is NxaMeets
                    {isMobile ? " " : <br />}
                    by NxaTel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    NxaMeets is a secure virtual meeting platform designed for
                    businesses of all sizes. It offers HD video conferencing,
                    screen sharing, AI-powered transcription, and cloud
                    recording, all with built-in security and compliance.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do I need to install an {isMobile ? " " : <br />}
                    app to use NxaMeets?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No! You can join instantly from your browser—no downloads
                    required. However, mobile apps for iOS and Android are
                    available for on-the-go meetings.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What security features does
                    {isMobile ? " " : <br />}
                    NxaMeets have?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    NxaMeets ensures end-to-end encryption, TLS 1.2+ signaling,
                    and AES-256 encryption. You can also enable secure lobbies,
                    password-protected meetings, and host controls to lock
                    meetings and remove participants.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I record my{isMobile ? " " : <br />} meetings?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! NxaMeets offers cloud recording based on your plan:{" "}
                    <br /> • Scale Up Plan: 6GB per host <br /> • Professional
                    Plan: 9GB per host, AI-powered transcription & meeting
                    keynotes <br />• Enterprise Plan: 10GB per organizer,
                    unlimited retention
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="number-of-boxIndex">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How many participants can
                    {isMobile ? " " : <br />}
                    join a meeting?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    • Startup Plan: Up to 25 participants <br />
                    • Scale Up Plan: Up to 100 participants <br />
                    • Professional Plan: Up to 200 participants <br />•
                    Enterprise Plan: Up to 500 participants
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do you offer a{isMobile ? " " : <br />} free trial?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! NxaMeets offers a 14-day free trial with full access to
                    premium features. No credit card required!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQMeetingPage;
